module.exports = __webpack_public_path__ + "static/img/Aions_GZ_Mar_5.483fa3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_GZ_Mar/Aions_GZ_Mar_5.png
// module id = cD+H
// module chunks = 19